// src/components/book/BookGrid.jsx
import React from 'react';
import BookCard from './BookCard';

const BookGrid = ({ books }) => {
  return (
    <div className="book-grid">
      {books.map(book => (
        <BookCard key={book.id} book={book} />
      ))}
    </div>
  );
};

export default BookGrid;